/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorRefill,
  PharmacyCounselorRefillFromJSON,
  PharmacyCounselorRefillFromJSONTyped,
  PharmacyCounselorRefillToJSON,
} from "./";

export const PutRefillRequestBodyTypename = "PutRefillRequestBody" as const;

/**
 *
 * @export
 * @interface PutRefillRequestBody
 */
export interface PutRefillRequestBody {
  /**
   *
   * @type {PharmacyCounselorRefill}
   * @memberof PutRefillRequestBody
   */
  refill: PharmacyCounselorRefill;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutRefillRequestBody
   */
  readonly __typename?: string;
}

export function PutRefillRequestBodyFromJSON(json: any): PutRefillRequestBody {
  return PutRefillRequestBodyFromJSONTyped(json, false);
}

export function PutRefillRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutRefillRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutRefillRequestBodyTypename,

    refill: PharmacyCounselorRefillFromJSON(json["refill"]),
  };
}

export function PutRefillRequestBodyToJSON(object?: PutRefillRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    refill: PharmacyCounselorRefillToJSON(value.refill),
  };
}
